<span [ngSwitch]="selectedRowGrid">
<div *ngSwitchCase="'row-grid-3'">
    <h3>Three Collections</h3>
    <div class="collection-list-3">
        <div class="grid-row grid-3">
            <ng-container *ngFor="let collectionItem of widewine; let i = index">
                <div *ngIf="i < 3" class="col-md-4 col-sm-6">
                    <div class="product-grid">
                        <div class="product-image">
                            <a href="#" class="image">
                                <img class="pic-1" src="{{collectionItem?.imageWithText?.src}}">
                            </a>
                            <span class="product-discount-label">33%</span>
                            <a class="product-like-icon" href="#"><i class="far fa-eye"></i></a>
                            <ul class="product-links">
                                <li><a href="#"><i class="fa fa-shopping-bag"></i></a></li>
                                <li><a href="#"><i class="fas fa-heart"></i></a></li>
                                <li><a href="#"><i class="fa fa-search"></i></a></li>
                            </ul>
                        </div>
                        <div class="product-content">
                            <div class="category-name"><a href="">Men's Clothing</a></div>
                            <div class="product-name"><a href="#">Men's T-Shirt</a></div>
                            <div class="price"><span>$46.99</span> $34.99</div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <h3>Three Collections Portrait</h3>
    <div class="collection-list-3 standard">
        <div class="grid-row grid-3">
            <ng-container *ngFor="let collectionItem of wine; let i = index">
                <div *ngIf="i < 3" class="col-md-4 col-sm-6">
                    <div class="product-grid">
                        <div class="product-image">
                            <a href="#" class="image">
                                <img class="pic-1" src="{{collectionItem?.imageWithText?.src}}">
                            </a>
                            <span class="product-discount-label">33%</span>
                            <a class="product-like-icon" href="#"><i class="far fa-eye"></i></a>
                            <ul class="product-links">
                                <li><a href="#"><i class="fa fa-shopping-bag"></i></a></li>
                                <li><a href="#"><i class="fas fa-heart"></i></a></li>
                                <li><a href="#"><i class="fa fa-search"></i></a></li>
                            </ul>
                        </div>
                        <div class="product-content">
                            <div class="category-name"><a href="">Men's Clothing</a></div>
                            <div class="product-name"><a href="#">Men's T-Shirt</a></div>
                            <div class="price"><span>$46.99</span> $34.99</div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<div *ngSwitchCase="'row-grid-4'">
    <h3>Four Standard</h3>
    <div class="collection-list-4">
        <div class="grid-row grid-row-4">
            <ng-container *ngFor="let collectionItem of plantItems; let i = index" class="col-md-3 col-sm-6">
                <div *ngIf="i < 4" class="col-md-3 col-sm-6">
                    <div class="product-grid">
                        <div class="product-image">
                            <a href="#" class="image">
                                <img class="pic-1" src="{{collectionItem?.imageWithText?.src}}">
                            </a>
                            <span class="product-discount-label">33%</span>
                            <a class="product-like-icon" href="#"><i class="far fa-eye"></i></a>
                            <ul class="product-links">
                                <li><a href="#"><i class="fa fa-shopping-bag"></i></a></li>
                                <li><a href="#"><i class="fas fa-heart"></i></a></li>
                                <li><a href="#"><i class="fa fa-search"></i></a></li>
                            </ul>
                        </div>
                        <div class="product-content">
                            <div class="category-name"><a href="">The Category Name</a></div>
                            <div class="product-name"><a href="#">The Product Name</a></div>
                            <div class="price"><span>R46.99</span> R34.99</div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="collection-list-4 standard">
        <div class="grid-row grid-row-4">
            <ng-container *ngFor="let collectionItem of collectionItems; let i = index" class="col-md-3 col-sm-6">
                <div *ngIf="i > 3 && i < 8" class="col-md-3 col-sm-6">
                    <div class="product-grid">
                        <div class="product-image">
                            <a href="#" class="image">
                                <img class="pic-1" src="{{collectionItem?.imageWithText?.src}}">
                            </a>
                            <span class="product-discount-label">33%</span>
                            <a class="product-like-icon" href="#"><i class="far fa-eye"></i></a>
                            <ul class="product-links">
                                <li><a href="#"><i class="fa fa-shopping-bag"></i></a></li>
                                <li><a href="#"><i class="fas fa-heart"></i></a></li>
                                <li><a href="#"><i class="fa fa-search"></i></a></li>
                            </ul>
                        </div>
                        <div class="product-content">
                            <div class="category-name"><a href="">The Category Name</a></div>
                            <div class="product-name"><a href="#">The Product Name</a></div>
                            <div class="price"><span>R46.99</span> R34.99</div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<div *ngSwitchCase="'row-grid-6'">
    <h3>Six wide</h3>
    <div class="collection-list-6">
        <div class="grid-row grid-row-6">
            <ng-container *ngFor="let collectionItem of preserves; let i = index" class="col-md-3 col-sm-6">
                <div *ngIf="i < 7" class="col-md-3 col-sm-6">
                    <div class="product-grid">
                        <div class="product-image">
                            <a href="#" class="image">
                                <img class="pic-1" src="{{collectionItem?.imageWithText?.src}}">
                            </a>
                            <span class="product-discount-label">33%</span>
                            <a class="product-like-icon" href="#"><i class="far fa-eye"></i></a>
                            <ul class="product-links">
                                <li><a href="#"><i class="fa fa-shopping-bag"></i></a></li>
                                <li><a href="#"><i class="fas fa-heart"></i></a></li>
                                <li><a href="#"><i class="fa fa-search"></i></a></li>
                            </ul>
                        </div>
                        <div class="product-content">
                            <div class="category-name"><a href="">The Category Name</a></div>
                            <div class="product-name"><a href="#">The Product Name</a></div>
                            <div class="price"><span>R46.99</span> R34.99</div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <h3>Six wide</h3>
    <div class="collection-list-6 standard">
        <div class="grid-row grid-row-6" kwEqualImageContainerHeight>
            <ng-container *ngFor="let collectionItem of food; let i = index" class="col-md-3 col-sm-6">
                <div *ngIf="i < 7" class="col-md-3 col-sm-6">
                    <div class="product-grid">
                        <div class="product-image">
                            <a href="#" class="image">
                                <img class="pic-1" src="{{collectionItem?.imageWithText?.src}}">
                            </a>
                            <span class="product-discount-label">33%</span>
                            <a class="product-like-icon" href="#"><i class="far fa-eye"></i></a>
                            <ul class="product-links">
                                <li><a href="#"><i class="fa fa-shopping-bag"></i></a></li>
                                <li><a href="#"><i class="fas fa-heart"></i></a></li>
                                <li><a href="#"><i class="fa fa-search"></i></a></li>
                            </ul>
                        </div>
                        <div class="product-content">
                            <div class="category-name"><a href="">The Category Name</a></div>
                            <div class="product-name"><a href="#">The Product Name</a></div>
                            <div class="price"><span>R46.99</span> R34.99</div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<div *ngSwitchCase="'row-grid-8'">
    <div class="collections-list-full">
        <div class="grid-row grid-row-8">
            <ng-container *ngFor="let collectionItem of wellnessItems; let i = index">
                <div *ngIf="i < 13" class="col-md-2 col-sm-4">
                    <div class="product-grid">
                        <div class="product-image">
                            <a href="#" class="image">
                                <img class="pic-1" src="{{collectionItem?.imageWithText?.src}}">
                            </a>
                            <span class="product-discount-label">33%</span>
                            <a class="product-like-icon" href="#"><i class="far fa-eye"></i></a>
                            <ul class="product-links">
                                <li><a href="#"><i class="fa fa-shopping-bag"></i></a></li>
                                <li><a href="#"><i class="fas fa-heart"></i></a></li>
                                <li><a href="#"><i class="fa fa-search"></i></a></li>
                            </ul>
                        </div>
                        <div class="product-content">
                            <div class="category-name"><a href="">The Category Name</a></div>
                            <div class="product-name"><a href="#">The Product Name</a></div>
                            <div class="price"><span>R46.99</span> R34.99</div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<div *ngSwitchDefault>
    <h3>Full Width Collection/Category Lists</h3>




    <h3>Four Collections</h3>
    <div class="collection-list-4 wider">
        <div class="row">
            <ng-container *ngFor="let collectionItem of collectionItems; let i = index" class="col-md-3 col-sm-6">
                <div *ngIf="i > 3 && i < 8" class="col-md-3 col-sm-6">
                    <div class="product-grid">
                        <div class="product-image">
                            <a href="#" class="image">
                                <img class="pic-1" src="{{collectionItem?.imageWithText?.src}}">
                            </a>
                            <span class="product-discount-label">33%</span>
                            <a class="product-like-icon" href="#"><i class="far fa-eye"></i></a>
                            <ul class="product-links">
                                <li><a href="#"><i class="fa fa-shopping-bag"></i></a></li>
                                <li><a href="#"><i class="fas fa-heart"></i></a></li>
                                <li><a href="#"><i class="fa fa-search"></i></a></li>
                            </ul>
                        </div>
                        <div class="product-content">
                            <div class="category-name"><a href="">Men's Clothing</a></div>
                            <div class="product-name"><a href="#">Men's T-Shirt</a></div>
                            <div class="price"><span>$46.99</span> $34.99</div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
</span>



